import React, { useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);
  const [pagesAccess, setPagesAccess] = useState([]);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedPagesAccess = JSON.parse(localStorage.getItem("pagesAccess"));
    const storedAdminId = localStorage.getItem("adminId");
    const storedEmployeeId = localStorage.getItem("employeeId");
    const storedRole = localStorage.getItem("role");

    if (!storedRole || (!storedAdminId && !storedEmployeeId)) {
      window.location.href = "/";
      return;
    }

    setRole(storedRole);
    if (storedPagesAccess) {
      setPagesAccess(storedPagesAccess);
    }

    if (storedAdminId) {
      setUserId(storedAdminId);
    } else if (storedEmployeeId) {
      setUserId(storedEmployeeId);
    }
  }, []);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
    setOpenSubDropdown(null);
  };

  const toggleSubDropdown = (name) => {
    setOpenSubDropdown(openSubDropdown === name ? null : name);
  };

  const handleLogout = async () => {
    try {
      await axios.post("https://api.elthiumhealth.com/api/admin/logout", {}, { withCredentials: true });
      localStorage.removeItem("authToken");
      localStorage.removeItem("employeeId");
      localStorage.removeItem("adminId");
      localStorage.removeItem("pagesAccess");
      localStorage.removeItem("role");
      alert("Logout successful");
      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
      alert("Logout failed. Please try again.");
    }
  };

  const elements = [
    {
      icon: <i className="ri-home-fill text-white text-xl"></i>,
      name: "Home",
      path: "/dashboard",
    },
    {
      icon: <i className="ri-folder-user-fill text-white text-xl"></i>,
      name: "Doctor Category",
      dropdown: [
        { name: "Create Category", path: "/create-category" },
        { name: "Get All Doctor Categories", path: "/doctorcategorylist" },
      ],
    },
    {
      icon: <i className="ri-building-fill text-white text-xl"></i>,
      name: "Companies",
      dropdown: [
        { name: "Add Company", path: "/company-register" },
        { name: "Company List", path: "/companylist" },
      ],
    },
    {
      icon: <i className="ri-file-search-fill text-white text-xl"></i>,
      name: "Diagnostics",
      dropdown: [
        { name: "Add Diagnostics", path: "/create-diagnostic" },
        { name: "Diagnostics List", path: "/diagnosticlist" },
        { name: "Diagnostics Bookings", path: "/diagnosticslist" },
        { name: "Appointment Booking", path: "/book-diagnostic" },
      ],
    },
    {
      icon: <i className="ri-user-heart-fill text-white text-xl"></i>,
      name: "Doctors",
      dropdown: [
        { name: "Add Doctor", path: "/create-doctor" },
        { name: "Doctor List", path: "/doctorlist" },
        { name: "Appointment List", path: "/appintmentlist" },
        { name: "Book An Appointment", path: "/appintmentbooking" },
      ],
    },
    {
      icon: <i className="ri-notification-2-line text-white text-xl"></i>,
      name: "Requests",
      dropdown: [
        { name: "Doctor Accepted Request", path: "/doctoracceptedlist" },
        { name: "Doctor Rejected Requests", path: "/doctorrejectedlist" },
        { name: "Diagnostic Accepted Request", path: "/diagnosticsacceptedlist" },
        { name: "Diagnostic Rejected Requests", path: "/diagnosticsrejectedlist" },
      ],
    },
    {
      icon: <i className="ri-health-book-line text-white text-xl"></i>,
      name: "HRA",
      dropdown: [
        { name: "Add HRA Category", path: "/create-hracat" },
        { name: "HRA CategoryList", path: "/categorylist" },
        { name: "Add HRA", path: "/add-hra" },
        { name: "Get All HRA", path: "/hralist" },
        { name: "All HRA Submitted List", path: "/hrasubmissionlist" },
        { name: "Question", path: "/question" },
        { name: "User Answers", path: "/answer" },
      ],
    },
    {
      icon: <i className="ri-article-line text-white text-xl"></i>,
      name: "Blog",
      dropdown: [
        { name: "Add Blogs", path: "/createblog" },
        { name: "Get All Blogs", path: "/bloglist" },
      ],
    },
    {
      icon: <i className="ri-clipboard-line text-white text-xl"></i>,
      name: "Test",
      dropdown: [
        { name: "Create Test", path: "/createtest" },
        { name: "Get All Tests", path: "/testlist" },
        { name: "Create Diagnostic Tests", path: "/creatediagtest" },
        { name: "Get All Diagnostic Tests", path: "/diagtestlist" },
      ],
    },
    {
      icon: <i className="ri-hospital-line text-white text-xl"></i>,
      name: "Scan & X-Ray",
      dropdown: [
        { name: "Create X-Rays", path: "/createxray" },
        { name: "Get All X-Rays", path: "/xraylist" },
      ],
    },
    {
      icon: <i className="ri-box-3-line text-white text-xl"></i>,
      name: "Packages",
      dropdown: [
        { name: "Create Package", path: "/create-package" },
        { name: "Get All Packages", path: "/package-list" },
      ],
    },
    {
      icon: <i className="ri-folder-upload-line text-white text-xl"></i>,
      name: "Medical Uploads",
      dropdown: [
        { name: "View Uploads", path: "/staffmedicaluplods" },
      ],
    },
    {
      icon: <i className="ri-user-line text-white text-xl"></i>,
      name: "Employee",
      dropdown: [
        { name: "Add Employee", path: "/create-employee" },
        { name: "Employee List", path: "/employeelist" },
      ],
    },
    {
      icon: <i className="ri-image-line text-white text-xl"></i>,
      name: "Banners",
      dropdown: [
        { name: "Add Banner", path: "/banner" },
      ],
    },
      {
      icon: <i className="ri-image-line text-white text-xl"></i>,
      name: "Customer Support Tickets",
      dropdown: [
        { name: "All Tickets", path: "/raisedtickets" },
      ],
    },
    {
      icon: <i className="ri-settings-3-line text-white text-xl"></i>,
      name: "Settings",
      path: "/setting",
    },
    {
      icon: <i className="ri-logout-box-fill text-white text-xl"></i>,
      name: "Logout",
      action: handleLogout,
    },
  ];

  // Filter elements based on role (admin or employee) and pagesAccess
  const filteredElements = elements.filter(item => {
    if (role === "admin") {
      return true;
    }

    if (role === "employee") {
      if (item.path && pagesAccess.includes(item.path)) {
        return true;
      }

      if (item.dropdown) {
        const filteredDropdown = item.dropdown.filter(subItem => pagesAccess.includes(subItem.path));
        if (filteredDropdown.length > 0) {
          item.dropdown = filteredDropdown;
          return true;
        }
        return false;
      }
    }

    return false;
  });

  return (
    <div
      className="w-64 h-screen overflow-y-auto no-scrollbar flex flex-col bg-blue-700"
    >
      {/* Header */}
      <div className="sticky top-0 z-10 bg-blue-700 shadow-md">
        <div className="flex justify-between items-center p-4">
          <span className="font-bold text-xl text-white tracking-wide">ElthiumHealth</span>
        </div>
      </div>

      <nav className="flex flex-col items-stretch space-y-1 mt-4 pb-8">
        {filteredElements.map((item, idx) => (
          <div key={idx} className="w-full">
            {item.dropdown ? (
              <>
                <div
                  className="flex items-center justify-between py-2.5 px-4 font-medium text-sm text-white mx-2 rounded-lg hover:bg-blue-700 hover:text-white duration-300 cursor-pointer transition-all"
                  onClick={() => toggleDropdown(item.name)}
                >
                  <div className="flex items-center">
                    <span className="text-xl">{item.icon}</span>
                    <span className="ml-3">{item.name}</span>
                  </div>
                  <FaChevronDown
                    className={`text-xs transform transition-transform duration-200 ${
                      openDropdown === item.name ? "rotate-180" : "rotate-0"
                    }`}
                  />
                </div>

                {/* Dropdown menu items */}
                {openDropdown === item.name && (
                  <div className="ml-8 mt-1 mb-2 space-y-1">
                    {item.dropdown.map((subItem, subIdx) => (
                      <Link
                        key={subIdx}
                        to={subItem.path}
                        className="flex items-center py-1.5 px-4 text-sm text-white/90 hover:text-white hover:bg-blue-700 rounded-lg transition-all duration-200"
                        onClick={() => {
                          setOpenDropdown(null);
                          setOpenSubDropdown(null);
                        }}
                      >
                        {subItem.name}
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : item.path ? (
              <Link
                to={item.path}
                className="flex items-center justify-start py-2.5 px-4 font-medium text-sm text-white mx-2 rounded-lg hover:bg-blue-700 hover:text-white duration-300 transition-all"
              >
                <span className="text-xl">{item.icon}</span>
                <span className="ml-3">{item.name}</span>
              </Link>
            ) : (
              <div
                className={`flex items-center justify-start py-2.5 px-4 font-medium text-sm text-white mx-2 rounded-lg hover:bg-blue-700 hover:text-white duration-300 cursor-pointer transition-all ${
                  item.name === "Logout" ? "mt-4" : ""
                }`}
                onClick={item.action}
              >
                <span className="text-xl">{item.icon}</span>
                <span className="ml-3">{item.name}</span>
              </div>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;